enum MeioPagamento {
  NaoIdentificado = 0,
  Boleto = 1,
  DebitoEmConta = 2,
  Pix = 3
}

export const opcoesMeioPagamento: MeioPagamento[] = [
  MeioPagamento.Boleto,
  MeioPagamento.Pix,
];

const meioPagamentoDicionario: Record<MeioPagamento, string> = {
  [MeioPagamento.NaoIdentificado]: 'Não identificado',
  [MeioPagamento.Boleto]: 'Boleto',
  [MeioPagamento.DebitoEmConta]: 'Débito em Conta',
  [MeioPagamento.Pix]: 'Pix',
};

export function meioPagamentoToString(meio: MeioPagamento): string {
  return meioPagamentoDicionario[meio];
}

export function meiosPagamentoToString(meios: MeioPagamento[]): string {
  return meios
    .map((meio) => meioPagamentoDicionario[meio])
    .join(' ou ');
}
export default MeioPagamento;
